import { Box, Container, Typography } from "@mui/material";
import FramedPhoto from "../components/FramedPhoto";
import { usePhoto } from "../Contexts/UsePhotoManifest";
import React from "react";
const AboutPage = () => {
    const portraitPhoto = usePhoto("KylieJeanPhotographyPortrait.jpg");
    const landscapePhoto = usePhoto("KylieJeanPhotographyLandscape.jpg"); // adjust to your actual landscape filename
    return (React.createElement(Box, { sx: { bgcolor: "#FAF6EF", minHeight: "100vh" } },
        React.createElement(Container, { maxWidth: "md", sx: { py: { xs: 6, sm: 10 } } },
            React.createElement(Typography, { component: "h1", sx: {
                    fontFamily: "'Cormorant Garamond', serif",
                    fontWeight: 500,
                    fontSize: { xs: "2.4rem", sm: "3rem" },
                    textAlign: "center",
                    mb: { xs: 5, sm: 7 },
                } }, "Get to know your photographer"),
            React.createElement(Box, { sx: {
                    position: "relative",
                    width: "100%",
                    maxWidth: 680,
                    mx: "auto",
                    mb: { xs: 8, sm: 10 }, // extra clearance for the portrait's overhang below
                } },
                landscapePhoto && (React.createElement(FramedPhoto, { src: landscapePhoto.src, frameColor: "primary.main.dark", frameWidth: 2, padding: 0 })),
                portraitPhoto && (React.createElement(Box, { sx: {
                        position: "absolute",
                        bottom: { xs: "-7%", sm: "-9%" },
                        right: { xs: "-4%", sm: "-6%" },
                        width: { xs: "38%", sm: "34%" },
                        zIndex: 2,
                        transform: "rotate(-2deg)", // very slight tilt, per the ask
                    } },
                    React.createElement(FramedPhoto, { src: portraitPhoto.src, frameColor: "primary.main.dark", frameWidth: 2, padding: 0 })))),
            React.createElement(Box, { component: "blockquote", sx: {
                    m: 0,
                    mb: 5,
                    mx: "auto",
                    maxWidth: 560,
                    pl: 3,
                    borderLeft: "2px solid #B9A88F",
                    fontFamily: "'Cormorant Garamond', serif",
                    fontStyle: "italic",
                    fontSize: { xs: "1.25rem", sm: "1.4rem" },
                    lineHeight: 1.5,
                    color: "#1B1812",
                } }, "My desire is to support you in building your own gallery of memories that allow you to cherish the little moments with the ones you love for a lifetime."),
            React.createElement(Box, { sx: {
                    fontFamily: "'Jost', sans-serif",
                    color: "#3A362E",
                    lineHeight: 1.85,
                    fontSize: "1.05rem",
                    maxWidth: 640,
                    mx: "auto",
                    "& p": { mb: 2.5 },
                    "& p:last-child": { mb: 0 },
                    // Drop cap on the opening paragraph — a classic editorial cue
                    // that this is a piece to be read, not a form field's worth
                    // of copy. Floated so the following lines wrap around it.
                    "& p.lead::first-letter": {
                        fontFamily: "'Cormorant Garamond', serif",
                        fontSize: "3.4rem",
                        fontWeight: 500,
                        lineHeight: 0.75,
                        float: "left",
                        pr: "10px",
                        pt: "6px",
                        color: "#1B1812",
                    },
                } },
                React.createElement("p", { className: "lead" }, "I'm a photographer based in Wheaton, IL. Photography has been a major part of my life since I got my first camera back in 2017. Helping you capture precious moments with the ones you love brings me so much joy! My background is in elementary and special education so I welcome any and all ages and abilities! I am constantly amazed at the way one photo can bring out so many memories and emotions."),
                React.createElement("p", null,
                    "My grandpa taught me the value of this through his",
                    " ",
                    React.createElement("em", null, "\"art gallery\""),
                    " in his office. He would hang random crafts we created for him and a million different photos of the people he loved on every wall of his office. Every inch was covered! Each one held a unique story that he could go on about for hours."),
                React.createElement("p", null, "Aside from photography, I love traveling to new places, going on hikes, and being out in nature. My music genre of choice is worship music and I am always in the middle of a book. When we travel, my husband always has to assure me that I do not need to bring more than one book. I am always up for an evening spent playing games with family and friends! Add some freshly-baked sweet treats and count me in!"),
                React.createElement("p", null, "Most importantly, I want my life and my work to be rooted in the gospel of Jesus Christ. What a joy it is to reflect on the creativity and sovereignty of God as I step into your story and capture your precious moments. It is my hope that I serve you with the same patience, kindness, and joy displayed by my savior, Jesus! All to Him I owe!"),
                React.createElement(Typography, { sx: {
                        fontFamily: "'Cormorant Garamond', serif",
                        fontStyle: "italic",
                        fontSize: "1.2rem",
                        color: "#5B5648",
                        mt: 4,
                        pt: 3,
                        borderTop: "1px solid rgba(27, 24, 18, 0.12)",
                    } }, "Thanks for reading! I cannot wait to get to know you!")))));
};
export default AboutPage;
